/**
 *
 * ProgressWrapper
 *
 */

import React from 'react';

import PropTypes from 'prop-types';

import { Mui } from '../..';
import SymbolLoading from '../../common/SymbolLoading';
import { useStyles } from './styles';

function ProgressWrapper(props) {
  const { loading, children, minHeight, symbol } = props;

  const classes = useStyles({ loading, minHeight });

  const renderIndicator = () => {
    if (!loading) return null;

    return symbol ? <SymbolLoading /> : <Mui.CircularProgress color="primary" />;
  };

  return (
    <div className={classes.root}>
      <Mui.Backdrop className={classes.backdrop} open={loading || false}>
        {renderIndicator()}
      </Mui.Backdrop>
      {children}
    </div>
  );
}

ProgressWrapper.propTypes = {
  loading: PropTypes.bool,
  minHeight: PropTypes.number,
  children: PropTypes.any,
  symbol: PropTypes.bool,
};

ProgressWrapper.defaultProps = {
  symbol: false,
};

export default ProgressWrapper;
